import BlockStyleControls from './BlockStyleControls'
export default BlockStyleControls



/** WEBPACK FOOTER **
 ** ./src/Editors/BlockStyleControls/index.js
 **/